import { useContext } from 'react';
import { I18nContext } from './I18nContextBase';

export function useI18n() {
  return useContext(I18nContext);
}
